import { createFileRoute } from '@tanstack/react-router';
import { User, Bell } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { NotificationsPreferences } from '@/components/notifications/notification-preferences';
import { UserSettings } from '@/components/user/user-settings';

export const Route = createFileRoute('/_authenticated/(user-dashboard)/dashboard/_dashboard/settings')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="container mx-auto px-4 py-6 max-w-6xl">
      <Tabs defaultValue="user" className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <h1 className="text-2xl font-bold">Settings</h1>
          <TabsList className="grid w-full sm:w-auto sm:max-w-md grid-cols-2">
            <TabsTrigger value="user" className="flex items-center justify-center gap-2 px-3 py-2">
              <User className="h-4 w-4" />
              <span className="hidden xs:inline">User</span>
            </TabsTrigger>
            <TabsTrigger value="notification" className="flex items-center justify-center gap-2 px-3 py-2">
              <Bell className="h-4 w-4" />
              <span className="hidden xs:inline">Notifications</span>
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="user" className="mt-6">
          <UserSettings />
        </TabsContent>

        <TabsContent value="notification" className="mt-6">
          <NotificationsPreferences />
        </TabsContent>
      </Tabs>
    </div>
  );
}
